import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import Wrp from '../../../hoc/Wrp/Wrp';
import { isSet } from '../../../Utils/CommonFunctions';

class BreadCrumbsButton extends Component {
  
    defaultOnclickHandler(){
      
    }
    render () {
      let historyList = null;
      historyList = this.props.breadCrumbsList.backHistory.map((item, i) => {
          const to = (item.href) ? item.href: "#";
          const eventsHandler = {
            onClick: (item.clickHandler) ? item.clickHandler : this.defaultOnclickHandler(),
           }
          return  <Wrp key={"wrp"+i}>
                  <li key={i} className="nav-item">
                    <LinkContainer to={to} {...eventsHandler}>
                    <a href={item.href} className="">{item.name}</a>
                    </LinkContainer>
                  </li>	
                  <li key={'arrow'+i}  className="separator">
                  <i className="fas fa-chevron-right fourth_light_color 1"></i>
                </li>
                </Wrp>
                  
                
      });
        return (
                <ul className="breadcrumbs">
                  {historyList}
                  <li className="nav-item d-inline-flex" title={""+isSet(this.props.breadCrumbsList.pageHoverTitle,'')}>
                    <div className="text-truncate" style={{maxWidth:'300px'}}>  {this.props.breadCrumbsList.pageTitle} </div>
                  </li>	
                </ul>
            
        )
    }
}

export default BreadCrumbsButton;